import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=6d4485d5"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=6d4485d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports